import { AlertTriangle } from "lucide-react";

interface ServiceBannerProps {
  /** "offline" = no internet; "mcp" = MCP search service unreachable */
  reason: "offline" | "mcp";
}

const MESSAGES: Record<ServiceBannerProps["reason"], string> = {
  offline:
    "You appear to be offline. New messages will fail until your connection returns.",
  mcp: "The search service is temporarily unavailable. Answers may be limited until it recovers.",
};

export function ServiceBanner({ reason }: ServiceBannerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center justify-center gap-2 border-b border-[var(--warning)]/40 bg-[var(--warning)]/10 px-4 py-2 text-center text-[12px] text-[var(--warning)]"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {MESSAGES[reason]}
    </div>
  );
}
